import React, { useEffect, useState } from 'react';
import { useTrialResult } from '@repository/ai/useAi';
import Main from './Main';
import OrderList from './OrderList';
import TutorialSection from './TutorialSection';
import LoginModal from '../../loginModal';
import { useScrollInteraction } from '@utils/hooks/useScrollInteraction/useScrollInteraction';
import classnames from 'classnames/bind';
import styles from './tutorial.module.scss';

const cx = classnames.bind(styles);

const Tutorial = () => {
  const { data: trialResult } = useTrialResult();

  const { onScrollClassName } = useScrollInteraction();

  useEffect(() => {
    if (window.location.hash) {
      switch (window.location.hash) {
        case 'tutorial2':
          const tutorial2 = document.getElementById('tutorial2');
          tutorial2 && tutorial2.scrollIntoView({ behavior: 'smooth' });
          return;
        case 'tutorial3':
          const tutorial3 = document.getElementById('tutorial3');
          tutorial3 && tutorial3.scrollIntoView({ behavior: 'smooth' });
          return;
        case 'tutorial4':
          const tutorial4 = document.getElementById('tutorial4');
          tutorial4 && tutorial4.scrollIntoView({ behavior: 'smooth' });
          return;
      }
    }

    window.scrollTo(0, 0);
  }, []);

  const [loginModalVisible, setLoginModalVisible] = useState(false);

  const openLoginModal = () => {
    setLoginModalVisible(true);
  };

  const closeLoginModal = () => {
    setLoginModalVisible(false);
  };

  return (
    <>
      <div className={cx('wrap')}>
        <Main />
        <OrderList />
        <TutorialSection
          id={'tutorial1'}
          title="환경체크"
          dec={
            <>
              꼼꼼한 환경체크로
              <br />
              <span className={cx('emphasis')}>
                편안한 응시환경을
                <br />
                만들어보세요.
              </span>
            </>
          }
          noticeList={[
            '웹 캠과 마이크 환경을 체크할 수 있어요.',
            '인식이 잘되지 않는 경우, 문제해결 가이드를 확인하세요.',
            '응시 중 유의사항을 미리 확인하고 준비할 수 있어요.',
          ]}
          time="5"
          url="calibration"
          openLoginModal={openLoginModal}
          state={trialResult?.result?.environmentCheck}
          type="type1"
          videoUrl="videoTutorial1.mp4"
          onScrollClassName={onScrollClassName}
        />
        <TutorialSection
          id={'tutorial2'}
          title="성향파악"
          dec={
            <>
              성향파악은
              <br />
              <span className={cx('emphasis')}>
                신속 정확이 생명!
                <br />
                유사 문항으로 연습해보세요.
              </span>
            </>
          }
          noticeList={[
            '실제와 유사한 20문항으로 구성되어 있어요.',
            '적절하게 시간을 배분하여 응답하는 방법을 익혀보세요.',
            '응시과정에 대해 상세한 결과를 확인할 수 있어요.',
          ]}
          time="5"
          url="likert"
          openLoginModal={openLoginModal}
          state={trialResult?.result?.likert}
          type="type2"
          videoUrl="videoTutorial2.mp4"
          onScrollClassName={onScrollClassName}
        />
        <TutorialSection
          id={'tutorial3'}
          title="전략게임"
          dec={
            <>
              어렵기만 했던 전략게임
              <br />
              <span className={cx('emphasis')}>
                체험하기로 쉽게
                <br />
                준비하세요.
              </span>
            </>
          }
          noticeList={[
            '실전과 똑같은 게임을 자유롭게 응시하며 연습할 수 있어요.',
            '총 8개의 전략게임에 대해 상세하게 설명해드려요.',
            '전략게임별 진단 결과를 확인할 수 있어요.',
          ]}
          time="15"
          url="practice"
          openLoginModal={openLoginModal}
          state={trialResult?.result?.strategyGame}
          type="type1"
          videoUrl="videoTutorial3.mp4"
          onScrollClassName={onScrollClassName}
        />
        <TutorialSection
          id={'tutorial4'}
          title="영상면접"
          dec={
            <>
              익숙하지 않았던 영상면접
              <br />
              <span className={cx('emphasis')}>
                셀프 질문으로 편하게
                <br />
                준비하세요.
              </span>
            </>
          }
          noticeList={[
            '원하는 질문을 설정하고 답변할 수 있어요.',
            '내가 답변하는 모습과 답변내용을 영상을 통해 점검할 수 있어요.',
            '셀프 체크 리스트를 통해 영상 면접 환경에 익숙해질 수 있어요.',
          ]}
          time="10"
          url="v4"
          openLoginModal={openLoginModal}
          state={trialResult?.result?.videoInterview}
          type="type2"
          videoUrl="videoTutorial4.mp4"
          onScrollClassName={onScrollClassName}
        />
      </div>
      <LoginModal
        subTitle="채용정보 · 역량검사 · 매칭까지"
        title="취업기회 지금 바로 잡다!"
        visible={loginModalVisible}
        onClose={closeLoginModal}
      />
    </>
  );
};

export default Tutorial;
